export const info = [
    {
        label: '运输单号',
        prop: 'ettmEttkNo'
    },
    {
        label: '客户订单',
        prop: 'ettaSoNo'
    },
    {
        label: '客户',
        prop: 'ettaCustomEbcuNameCn'
    },
    {
        label: '收货单位',
        prop: 'ettaConsigneeEbspNameCn'
    },
    {
        label: '收货联系人',
        prop: 'ettaToContactName'
    },
    {
        label: '收货联系方式',
        prop: 'ettaToContactMobile'
    },
    {
        label: '收货地址',
        prop: 'ettaToEbrgAddress'
    },
    {
        label: '商品名称',
        prop: 'ettmEbmaNameCn'
    },
    {
        label: '产品编码',
        prop: 'ettmMaterialNo'
    },
    {
        label: '包装规格',
        prop: 'ettmEbtpPackageType'
    },
    {
        label: '单位',
        prop: 'ettmEbtpPackage'
    },
    {
        label: '单台体积',
        prop: 'ettmPackageVolumn'
    },
    {
        label: '单台重量',
        prop: 'ettmPackageGrossWeight'
    },
    {
        label: '数量',
        prop: 'ettmQuantity'
    },
    {
        label: '体积',
        prop: 'ettmVolume'
    }
];
export const record = [
    {
        label: '跟踪时间',
        prop: 'etisDate'
    },
    {
        label: '跟踪地点',
        prop: 'etisLocation'
    },
    {
        label: '是否异常',
        prop: 'etisIsAbnormal'
    },
    {
        label: '跟踪方式',
        prop: 'etisTrackingWay'
    },
    {
        label: '跟踪人',
        prop: 'etisTracer'
    },
    {
        label: '备注',
        prop: 'etisRemark'
    }
];
export const abnormal = [
    {
        label: '发车单号',
        prop: 'ettgEtdoNo'
    },
    {
        label: '异常分类',
        prop: 'ettgAbnormalClass'
    },
    {
        label: '异常类型',
        prop: 'ettgAbnormalType'
    },
    {
        label: '登记人',
        prop: 'ettgRegistrant'
    },
    {
        label: '跟踪地点名称',
        prop: 'ettgEtisLocation'
    },
    {
        label: '备注',
        prop: 'ettgRemark'
    }
];